import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef} from '@angular/core';
import {MatMenu} from '@angular/material/menu';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html',
    styleUrls: ['./multi-select-dropdown.component.scss'],
    standalone: false
})
export class MultiSelectDropdownComponent implements OnInit, AfterViewInit {

  @Input() filterGroup: any;
  @Output() changed = new EventEmitter();
  @ViewChild('menu', { static: true }) private menu: MatMenu;
  selectedItems: any;
  private destroyRef = inject(DestroyRef);

  constructor() {
  }

  ngOnInit(): void {
    this.resetFilter(true);
  }

  ngAfterViewInit(): void {
    this.menu.overlayPanelClass = 'mat-menu-panel';
  }

  selectFilterTypes(fieldFilterItem, $event: any): void {
    fieldFilterItem.selected = !fieldFilterItem.selected;
    $event.stopPropagation();
  }

  resetFilter(skipApplyFilter?: boolean): void {
    this.filterGroup?.forEach(item => item.selected = false);
    if (!skipApplyFilter) {
      this.applyFilter();
    }
  }

  applyFilter(): void {
    this.selectedItems = [];
    for (const item of this.filterGroup) {
      if (item.selected) {
        this.selectedItems.push(item);
      }
    }
    this.changed.emit(this.selectedItems);
  }
}
